<template>
  <div id="app">
    <!-- HELLO WORD -->
    <section id="start" class="hero is-danger is-bold is-fullheight">
      <div class="hero-body">
        <div class="container has-text-centered">
          <h1 class="title">Hello world.</h1>
          <h2 class="subtitle">
            <a href="#whoami" v-smooth-scroll>whoami</a> /
            <a href="#work" v-smooth-scroll>work</a> /
            <a href="#contact" v-smooth-scroll>contact</a>
          </h2>
        </div>
      </div>
    </section>

    <!-- WHOAMI -->
    <section id="whoami" class="hero is-light is-fullheight">
      <div class="hero-body">
        <div class="container has-text-centered">
          <h1 class="title">{{ whoami }}</h1>
          <h2 class="subtitle">
            <a @click="whoami = 'gasper rataj.'">real life</a> /
            <a @click="whoami = 'friderik / friderikceljski.'">online</a>
          </h2>
        </div>
      </div>
    </section>

    <!-- WORK -->
    <section id="work" class="hero is-dark is-bold is-fullheight">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">currently a student and an intern.</h1>
          <h2 class="subtitle">
            <strong>student at: </strong>University of Ljubljana - Faculty of
            Computer and Information Sciences
            <br />
            <strong>currently working at: </strong>
            <a href="https://www.petrol.eu/" target="blank"
              >Petrol d.d., Ljubljana</a
            >
          </h2>
          <p>
            As an intern I have job experience in the field of system
            integrations. I so far worked with network monitoring tools using
            SNMP (Zabbix and PRTG), virtual machines (VMware ESXi), I also
            crossed paths with Active Directory LDAP, Microsoft Server and Linux
            server (Redhat, CentOS) operating systems.
          </p>
          <p style="margin-top: 1rem">
            Apart from IT, I love software development. I am currently getting
            ahold of a few web technologies (VENoM/MEVN stack) and Kotlin in the
            field of Android development. I also worked with C#, Java, Python,
            ASP .NET, MS SQL, K8s, Docker and Vagrant.
          </p>
          <p style="margin-top: 1rem">
            I am currently in pursuit of 2 month compulsory internship. Still
            being a student, I would love to put some work in open source
            projects in this time. Looking ahead in my career, I would like to
            profound myself in the field of project management and information
            systems development.
          </p>
          <p style="margin-top: 1rem">
            You can check some of my stuff on
            <a href="https://github.com/friderikceljski">Github</a>. I am still
            working on pushing some more repos on it.
          </p>
        </div>
      </div>
    </section>

    <!-- CONTACT -->
    <section id="contact" class="hero is-light is-fullheight">
      <div class="hero-body">
        <div class="container has-text-centered">
          <h1 class="title">{{ contact }}</h1>
          <h2 class="subtitle">
            <a @click="contact = 'me (at) gasperataj.si'">mail</a> /
            <a @click="contact = 'friderik#2012'">discord</a> /
            <a
              href="https://www.linkedin.com/in/ga%C5%A1per-r-75126b109/"
              target="blank"
              >linkedin</a
            >
            /
            <a href="https://github.com/friderikceljski" target="blank">Github</a>
          </h2>
        </div>
      </div>
    </section>

    <!-- BACK TO THE TOP BUTTON -->
    <a href="#start" v-smooth-scroll>
      <i class="fas fa-arrow-up back2top is-dark"></i>
    </a>
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      whoami: "gasper rataj.",
      contact: "me (at) gasperataj.si",
    };
  },
  mounted: function() {
    let arrowUp = document.getElementsByClassName("back2top")[0];
    window.addEventListener("scroll", () => {
      if (window.pageYOffset > 300) {
        arrowUp.style.display = "block";
        arrowUp.classList.remove("btnExit");
        arrowUp.classList.add("btnEntrance");
      } else {
        setTimeout(() => {
          arrowUp.style.display = "none";
        }, 250);
        arrowUp.classList.remove("btnEntrance");
        arrowUp.classList.add("btnExit");
      }
    });
  },
};
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
$danger: #d22727;

a:hover {
  font-weight: 500;
}

.back2top {
  display: none;
  cursor: pointer;
  border-radius: 50%;
  font-size: 1rem;
  padding: 1rem;
  background-color: rgb(255, 255, 255);
  color: rgb(118, 118, 118);
  position: fixed;
  bottom: 2rem;
  right: 2rem;

  border: 0.01rem solid rgb(177, 177, 177);
  -webkit-box-shadow: 4px 3px 9px 0px rgba(79, 78, 79, 0.25);
  -moz-box-shadow: 4px 3px 9px 0px rgba(79, 78, 79, 0.25);
  box-shadow: 4px 3px 9px 0px rgba(79, 78, 79, 0.25);
}

/* animations */
.btnEntrance {
  animation-duration: 0.5s;
  animation-fill-mode: both;
  animation-name: btnEntrance;
}

@keyframes btnEntrance {
  from {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  to {
    opacity: 1;
  }
}

.btnExit {
  animation-duration: 0.5s;
  animation-fill-mode: both;
  animation-name: btnExit;
}

@keyframes btnExit {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
}
</style>
